// PasswordReset.js

import React, { useState } from 'react';
import { useParams, useNavigate,useLocation  } from 'react-router-dom';
import { Form, Button, Alert } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { resetPassword } from './../api';

const PasswordReset = () => {
    const title = 'Forgot Password';
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const { token } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const resetToken = token || new URLSearchParams(location.search).get('token');
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        try {
            
            await resetPassword(resetToken, password);
            setMessage('Password reset successful. You can now log in with your new password.');
            setTimeout(() => navigate('/login'), 3000);
        } catch (err) {
            setError('Failed to reset password. Please try again.');
        }
    };

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <main className="container-auth">
                <Form onSubmit={handleSubmit}>
                    <div className="row mb-3">
                        <div className="text-center">
                   {/*          <i className="bi bi-file-lock-fill auth-icon fw-normal mt-5 text-center" /> */}
                        </div>
                    </div>
                    <h2 className="text-center">Reset Password</h2>

                    <Form.Group className="mb-3" >
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Enter new password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" >
                        <Form.Label>Confirm New Password</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Confirm new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Button className="w-100 btn btn-lg btn-primary mt-2 " type="submit">
                        Reset Password
                    </Button>

                </Form>
                {message && <Alert variant="success">{message}</Alert>}
                {error && <Alert variant="danger">{error}</Alert>}
            </main>
        </>
    );
};

export default PasswordReset;